import React from "react";
import svg10 from "../../assets/svg/svg10.svg";
import svg41 from "../../assets/svg/svg41.svg";
import svg42 from "../../assets/svg/svg42.svg";
import svg43 from "../../assets/svg/svg43.svg";
import svg44 from "../../assets/svg/svg44.svg";
import svg45 from "../../assets/svg/svg45.svg";
import { useNavigate } from "react-router-dom";

const items = [
  {
    title: "Bulk Payment",
    svg: svg42,
    desc: "Upload, approve, and disburse to hundreds in seconds. Simplify payroll, vendor bills, and bulk transactions all in just a few clicks",
    navigationId: "bulk-payment",
  },
  {
    title: "Petty Cash Management",
    svg: svg43,
    desc: "Easily allocate, track, and reconcile petty cash with real-time insights and control over daily expenses.",
    navigationId: "petty-cash",
  },
  {
    title: "Bill & Supplier Settlements",
    svg: svg44,
    desc: "Pay bills and suppliers on time with automated, verified transactions. Simple, fast, and reliable.",
    navigationId: "bill-settlement",
  },
  {
    title: "Airtime & Data Bundles",
    svg: svg45,
    desc: "Keep your teams connected with instant, bulk airtime and data top-ups.",
    navigationId: "airtime-data",
  },
];

function Payments({ setActive }) {
  const navigate = useNavigate();

   
    const handleRegister = async () => {
    window.location.href="https://app.ndovupay.org/#/registration"
  };

  const handleCardClick = (navigationId) => {
    setActive(navigationId);
  };

  const handleInquire = () => {
    setActive('contact');
  };
  return (
    <div className="flex lg:flex-row flex-col justify-between gap-[2rem] lg:gap-[3rem]">
      <div className="flex flex-col w-full lg:max-w-[40%]">
        <div className="text-[#323232] text-[1.75rem] md:text-[2.25rem] font-[600] leading-[2.625rem] max-w-full lg:max-w-[24rem]">
          Everything You Need to Run Smarter Payments
        </div>
        <div className="mt-[1.25rem] text-[#4F4770] text-[.875rem] font-[400] leading-[1.5rem] max-w-full lg:max-w-[16.75rem]">
          From bulk disbursements to petty cash and wallets, manage all your
          financial operations in one place.
        </div>
        <div className="mt-[4rem] gap-[.62rem] flex flex-wrap">
          {" "}
          <button className="cstm-btn-2 !min-w-[12.625rem] !w-auto" onClick={handleRegister}>
            Create Account <img src={svg10} alt="svg10" />
          </button>
          <button className="cstm-btn !min-w-[10rem] !w-auto" onClick={handleInquire}>Inquire</button>
        </div>

        <div className="lg:mt-[9.06rem] mt-[3rem] flex text-center items-center justify-center lg:justify-start">
          <img src={svg41} alt="svg41" className="max-w-full h-auto" />
        </div>
      </div>

      <div className="grid lg:grid-cols-2 grid-cols-1 gap-[1.5rem] lg:gap-[2rem] w-full flex-1">
        {items &&
          items?.map((item, index) => {
            const marginTopClasses = [
              "lg:mt-[3rem]",
              "lg:mt-0", 
              "lg:mt-[4.5rem]",
               "lg:mt-[1.5rem]",
            ];
            return (
              <div
                key={index}
                onClick={() => handleCardClick(item?.navigationId)}
                className={`rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(0,0,0,0.07)] px-[1.5rem] md:px-[2rem] py-[1.56rem] flex-shrink-0 w-full cursor-pointer hover:shadow-[0_4px_20px_0_rgba(0,0,0,0.12)] transition-shadow ${marginTopClasses[index]}`}
              >
                <img src={item?.svg} alt={item?.svg} className="max-w-full h-auto" />
                <div className="text-[#1E191B] mt-[1.37rem] text-[1.125rem] font-[600] leading-[1.625rem]">
                  {item?.title}
                </div>
                <div className="mt-[1.12rem] text-[#7A7493] text-[.875rem] font-[400] leading-[1.5rem] max-w-full lg:max-w-[13.4375rem]">
                  {item?.desc}
                </div>
                {index === 3 && (
                  <button className="mt-[3.94rem] bg-[#1E191B] text-white rounded-[624.9375rem] px-[1rem] py-[0.5rem] text-[.875rem] font-[400] flex items-center gap-[0.5rem] whitespace-nowrap">
                    Top up
                    <img src={svg10} alt="svg10" />
                  </button>
                )}
              </div>
            );
          })}
      </div>
    </div>
  );
}

export default Payments;
